import { IframeWindow } from '.';
import { BaseRequest } from '../../api';
import { system } from '../../api/system';

export class System implements system.Api {
  private _systemInfo: system.SystemInfo;

  constructor(private iframe: IframeWindow) {}

  openTwitter(request: BaseRequest): void {
    throw new Error('Not supported');
  }

  close(): void {
    this.iframe.postMessage({ command: 'system.close' });
  }

  hide(): void {
    this.iframe.postMessage({ command: 'system.hide' });
  }

  wait(request?: system.MessageRequest): void {
    this.iframe.postMessage({ command: 'system.wait', args: request });
  }

  resume(): void {
    this.iframe.postMessage({ command: 'system.resume' });
  }

  cancelClose(): void {
    this.iframe.postMessage({ command: 'system.cancelClose' });
  }

  alert(request: system.MessageRequest): void {
    this.iframe.postMessage({ command: 'system.alert', args: request });
  }

  error(request: system.MessageRequest): void {
    this.iframe.postMessage({ command: 'system.error', args: request });
  }

  openDialog(request: system.DialogRequest): Promise<boolean> {
    return this.iframe.twoWayCall<system.DialogRequest, boolean>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'system.openDialog',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        return response;
      }
    );
  }

  openDialogV2(request: system.DialogRequest): Promise<system.DialogButtonType> {
    return this.iframe.twoWayCall<system.DialogRequest, system.DialogButtonType>(
      request,
      (requestId, request) => {
        this.iframe.postMessage({
          command: 'system.openDialog',
          args: {
            ...request,
            requestId,
          },
        });
      },
      (response) => {
        if (response === true) return system.DialogButtonType.Confirm;
        else if (response === false) return system.DialogButtonType.Refuse;

        return response;
      }
    );
  }

  openUrl(config: system.BrowserConfig): void {
    this.iframe.postMessage({ command: 'system.openUrl', args: config });
  }

  openUrlV2(config: system.BrowserConfigV2): void {
    this.iframe.postMessage({ command: 'system.openUrl', args: config });
  }

  getSystemInfo(): Promise<system.SystemInfo> {
    if (this._systemInfo) {
      return Promise.resolve(this._systemInfo);
    }
    return this.iframe.twoWayCall<system.SystemInfo, system.SystemInfo>(
      null,
      (requestId) => {
        this.iframe.postMessage({
          command: 'system.getSystemInfo',
          args: { requestId },
        });
      },
      (response) => {
        this._systemInfo = response;
        return response;
      }
    );
  }

  getFeatureList(forceRefresh?: boolean): Promise<system.FeatureList> {
    throw new Error('Method not implemented.');
  }

  setWindowTitle(request: system.SetWindowTitleRequest): void {
    this.iframe.postMessage({ command: 'system.setWindowTitle', args: request });
  }

  onBeforeClose(handler: () => Promise<boolean>): void {
    handler().then((shouldCancelClose) => {
      if (shouldCancelClose) {
        this.cancelClose();
      }
    });
  }

  send(request: any, hasResponse: boolean = false): Promise<any> {
    if (!this.iframe.isTrustedApp) {
      throw new Error('Permission error');
    }

    if (hasResponse) {
      return this.iframe.internalSendAsync(request);
    }

    this.iframe.internalSend(request);
    return Promise.resolve();
  }

  finishLoading(): void {
    this.iframe.postMessage({ command: 'system.finishLoading' });
  }

  enableCloseConfirmation(request: system.enableCloseConfirmationRequest): void {
    this.iframe.postMessage({ command: 'system.enableCloseConfirmation', args: request });
  }
}
